import { date, number, string } from "yup";
import * as Yup from "yup";

export const validateField = async (value, validators) => {
  let error = "";

  if (!validators) return error;

  error = (
    await Promise.all(
      validators.map(async ({ identifier, options }) => {
        if (!validatorMap[identifier]) {
          console.error(`Validator ${identifier} doesn't exist.`);
          return "";
        }
        const result = await validatorMap[identifier](value, options);
        return result;
      })
    )
  ).filter((v) => !!v)[0];
  return error;
};

function convertFileSizeToBytes(fileSize: string) {
  const units = {
    B: 1,
    K: 1024,
    M: 1024 * 1024,
    G: 1024 * 1024 * 1024,
    T: 1024 * 1024 * 1024 * 1024,
  };

  const matches = fileSize.match(/^(\d+)([BKMGT]B?)$/i);
  if (!matches) {
    throw new Error("Invalid file size format");
  }

  const size = parseInt(matches[1], 10);
  const unit = matches[2].toUpperCase();

  if (!units[unit]) {
    throw new Error("Invalid file size unit");
  }

  return size * units[unit];
}

export const validatorMap = {
  Alphanumeric: async (value: string) => {
    const schema = string().matches(/^[a-z0-9]+$/i);
    return validate(schema, value);
  },
  Count: async (value: string) => {
    const schema = number();
    return validate(schema, value);
  },
  DateRange: async (value: string) => {
    const schema = date();
    return validate(schema, value);
  },
  DateTime: async (value: string) => {
    const schema = date();
    return validate(schema, value);
  },
  EmailAddress: async (value: string) => {
    const schema = string().email("Bitte korrekt Emailadresse angeben");
    return validate(schema, value);
  },
  FileSize: async (value: any, options) => {
    const min = convertFileSizeToBytes(options?.minimum) || 0;
    const max = convertFileSizeToBytes(options?.maximum) || 0;
    const schema = number().min(min).max(max);
    return validate(schema, value?.size);
  },
  Float: async (value: string) => {
    const schema = number();
    return validate(schema, value);
  },
  Integer: async (value: string) => {
    const schema = number().integer();
    return validate(schema, value);
  },
  NotEmpty: async (value: any) => {
    let schema;
    if (typeof value === "number") {
      schema = number()
        .oneOf(
          [1],
          "Bitte akzeptieren Sie unsere Datenschutzbestimmungen, um fortzufahren.*"
        )
        .required();
    } else schema = string().required("Bitte Wert angeben");
    return validate(schema, value);
  },
  Number: async (value: string) => {
    const schema = number();
    return validate(schema, value);
  },
  NumberRange: async (value: string) => {
    const schema = number();
    return validate(schema, value);
  },
  RegularExpression: async (value: string) => {
    const schema = string();
    return validate(schema, value);
  },
  StringLength: async (value: string) => {
    const schema = string().min(3);
    return validate(schema, value);
  },
  Text: async (value: string) => {
    const schema = string();
    return validate(schema, value);
  },
  NotInBlacklist: async (value: string) => {
    const schema = string();
    return validate(schema, value);
  },
  Phone: async (value: string) => {
    const schema = number();
    return validate(schema, value);
  },
};

const validate = async (schema, value) => {
  return await schema
    .validate(value)
    .then(() => null)
    .catch((e) => e.message);
};
